var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection2Img2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 81,
    viewBox: "0 0 85 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 79H8M83.5 79H75.5M8 79V35.5M8 79H18M20.5 35.5V28.5H8V35.5M20.5 35.5H8M20.5 35.5H35.5M35.5 35.5V79M35.5 35.5V9H41.5M35.5 79H26.5M35.5 79H50M75.5 79V9H70M75.5 79H61M41.5 9V2H70V9M41.5 9H70M15 41.5V64M22 41.5V64M29 41.5V64M26.5 79H18M26.5 79V69.5H18V79M50 79V64H61V79M50 79H61M44 45.5V53H51.5V45.5H44ZM59.5 45.5H67.5V53H59.5V45.5ZM59.5 39H67.5V31.5H59.5V39ZM51.5 39H44V31.5H51.5V39ZM51.5 24.5H44V17H51.5V24.5ZM59.5 24.5H67.5V17H59.5V24.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Img2);
export default __webpack_public_path__ + "static/media/section2img2.8860c3401d0fdde496c4c8eb69f0900a.svg";
export { ForwardRef as ReactComponent };